import moment from 'moment'

import {
  IAPIHICustomer,
  IHICustomer,
  IHICustomerDetails,
} from '../interfaces/IHealthInsurance'

export const transformCustomerToAPICustomer = ({
  customer,
  details,
}: {
  customer: IHICustomer
  details: IHICustomerDetails
}): IAPIHICustomer => ({
  id: customer.customerId,
  uuid: '',
  first_name: customer.firstName,
  last_name: customer.lastName,
  image: null,
  is_man: true,
  gender: details.gender,
  street: details.address,
  postal: details.postalCode,
  city: details.city,
  country: details.country,
  invoice_health_insurance_number: details.healthInsuranceNumber || '',
  birth_day: moment(details.birthDay).format('YYYY-MM-DD') || null,
  invoice_extra_info: details.extraInfo,
  bsn_code: details.bsnCode
})
